import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next"
import { useConfigurationModule } from "../../../../../../Settings/Configuration/hooks/useConfigurationModule";
import { isAddedTimeSheet } from "../../../helpers";

export const useNoteValidations = (type = "myTimesheet") => {
    const { t } = useTranslation();
    const mandatoryNoteOnEdit = useConfigurationModule(`${type}.mandatoryNoteOnEdit`);
    const mandatoryNoteOnCreate = useConfigurationModule(`${type}.mandatoryNoteOnCreate`);

    const isRequired = useCallback((value, row) => {
        if (isAddedTimeSheet(row) && !row.note && !!mandatoryNoteOnCreate) {
            return t("required-note");
        }
        if (!isAddedTimeSheet(row) && (!value || value === "") && !!mandatoryNoteOnEdit) {
            return t("required-note");
        }
        return null;
    }, [mandatoryNoteOnEdit, mandatoryNoteOnCreate, t]);
    return useMemo(() => [isRequired], [isRequired])
}